import { Circle, SkeletonCircle } from '@chakra-ui/react'

import { useGlobalUnresolvedIncidentsCountQuery } from '@/graphql/generated/hooks'

const INCIDENTS_COUNT_POLL_INTERVAL = 60_000

export const IncidentsCount = () => {
  const { data: totalCountData, loading: isLoading } =
    useGlobalUnresolvedIncidentsCountQuery({
      pollInterval: INCIDENTS_COUNT_POLL_INTERVAL,
    })
  const totalCount = totalCountData?.globalUnresolvedIncidentsCount?.totalCount

  return isLoading ? (
    <SkeletonCircle paddingX='8px' size='22px' />
  ) : (
    <Circle
      bgColor='#D11D3A'
      color='#fff'
      data-testid='notificationsTab_activeIncidents_countBadge'
      fontSize='12px'
      fontWeight='bold'
      h='22px'
      paddingX='8px'
    >
      {totalCount}
    </Circle>
  )
}
